<template>
  <v-dialog v-model="show" fullscreen transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title> Buscar Jugador </v-toolbar-title>
      </v-toolbar>
      <v-alert color="purple" dark dismissible outlined
        >Si aprieta el botón "BUSCAR" sin ingresar nada en los campos de
        apellidos y nombres, traerá todos los jugadores de la
        institución.</v-alert
      >
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="apellidos"
              prepend-icon="mdi-account"
              label="Apellidos"
              maxlength="50"
              dense
              @keypress.enter="handleBuscarPacientes()"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="nombres"
              prepend-icon="mdi-account"
              label="Nombres"
              maxlength="50"
              dense
              @keypress.enter="handleBuscarPacientes()"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="mt-0 pt-0">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click.stop="handleBuscarPacientes()"
          :disabled="loading"
          :loading="loading"
          >Buscar
          <v-icon dark right>mdi-magnify</v-icon>
        </v-btn>
      </v-card-actions>

      <v-data-table
        :headers="headers"
        :items="this.listaPacientes"
        class="elevation-1"
        locale="es-ar"
        item-key="idPaciente"
        :disable-sort="true"
        :items-per-page="10"
        :server-items-length="cantRegistros"
        :footer-props="{
          itemsPerPageText: 'Filas por página',
          itemsPerPageOptions: [5, 10, 15],
        }"
        :options.sync="options"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                class="mr-3"
                color="primary"
                v-on="on"
                v-bind="attrs"
                @click="seleccionarPaciente(item)"
                >mdi-checkbox-marked-circle</v-icon
              >
            </template>
            <span>Seleccionar Jugador</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-card-actions class="paciente-acciones">
        <v-btn dark color="#24232d" @click="show = false">
          <v-icon left>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" @click.stop="nuevoPaciente">Nuevo Jugador</v-btn>
      </v-card-actions>
      <NuevoJugador
        :visible="showNuevoPaciente"
        @close="cierraNuevoPaciente"
      ></NuevoJugador>
    </v-card>
  </v-dialog>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>
import axios from "@/axios-auth";
import { showAlert } from "@/utils/toast";
import NuevoJugador from "../Gestion/Jugadores/NuevoJugador.vue";

export default {
  data: (vm) => ({
    apellidos: null,
    nombres: null,
    headers: [
      {
        text: "Apellidos",
        align: "start",
        filterable: false,
        value: "apellidos",
      },
      { text: "Nombres", value: "nombres" },
      { text: "Documento", value: "nrodocumento" },
      { text: "Categoría", value: "categoria" },
      { text: "Seleccionar", value: "actions", sortable: false },
    ],
    listaPacientes: [],
    loading: false,
    options: {
      page: 1,
      itemsPerPage: 10,
    },
    cantRegistros: null,
    showNuevoPaciente: false,
  }),
  components: {
    NuevoJugador,
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.vaciarModels();
          this.$emit("close");
        }
      },
    },
  },
  watch: {
    options: {
      deep: true,
      handler(val) {
        if (Object.keys(val).length) {
          this.buscarPaciente();
        }
      },
    },
  },
  props: ["visible"],
  methods: {
    cierraNuevoPaciente(datosPaciente) {
      this.showNuevoPaciente = false;
      this.apellidos = datosPaciente.apellidos;
      this.nombres = datosPaciente.nombres;
      this.buscarPaciente();
    },
    nuevoPaciente() {
      this.showNuevoPaciente = true;
    },
    handleBuscarPacientes() {
      this.options.page = 1;
      this.buscarPaciente();
    },
    buscarPaciente() {
      const pacientesData = {
        apellidos: this.apellidos,
        nombres: this.nombres,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };
      this.loading = true;
      let self = this;
      axios
        .get("/Paciente/GetPacientesApeNom?", {
          params: {
            apellidos: pacientesData.apellidos,
            nombres: pacientesData.nombres,
            idInstitucion: pacientesData.idInstitucion,
            page: this.options.page,
            items: this.options.itemsPerPage,
          },
        })
        .then(function (response) {
          if (response.data != "" && response.data != null) {
            self.listaPacientes = response.data.listaPacientes;
            self.cantRegistros = response.data.cantRegistros;
          } else {
            self.cantRegistros = 0;
            self.listaPacientes = [];
            self.showAlert({
              icon: "warning",
              title:
                "No hay jugadores que coincidan con los filtros de búsqueda.",
              vm: self,
              timer: 2000,
            });
          }
          self.loading = false;
        })
        .catch(function (error) {
          self.loading = false;
        });
    },
    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
    vaciarModels() {
      this.listaPacientes = [];
      this.apellidos = [];
      this.nombres = [];
      this.cantRegistros = 0;
    },
    seleccionarPaciente(item) {
      this.vaciarModels();
      this.$emit("seleccionarPaciente", item);
    },
  },
};
</script>
